import {
  Flex,
  Text,
  Input,
  Button,
  Image,
  InputGroup,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { VARIANT, WHITE } from "../../../constants/colors";
import { goToDashboard } from "../../../routes/coordinator";
import { useNavigate } from "react-router-dom";
import imagem from "../../../assets/images/logo-big.png";
import Login from "../../../services/loginApi";
import { useRecoilState, useSetRecoilState } from "recoil";
import { LoggedUser } from "../../../atoms/userLogged";
import axios from "axios";
import PermissionsAPI from "../../../services/permissionsAPI";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import { permissions } from "../../../atoms/permissions";
import { allPermissions } from "../../../atoms/allPermissions";
import moment from "moment";
import md5 from "md5";
import { openConfirmTerms } from "../../../atoms/openConfirmTerms";
import ModalRequestNewPassword from "./modalRequestNewPassword";
import { useCookies } from "react-cookie";
import ModalSelectEmail from "./modalSelectEmail";
import { atom } from "recoil";
import { apiResponseState } from "../../../atoms/loginState";
function LoginForm() {
  const initialValues = {
    pwd: "",
    email: "",
    secret: "",
  };
  const navigate = useNavigate();
  const [apiResponse, setApiResponse] = useRecoilState(apiResponseState);
  const setOpen = useSetRecoilState(openConfirmTerms);
  const [cookies, setCookie, removeCookie] = useCookies();
  const [values, setValues] = useState(initialValues);
  const setUser = useSetRecoilState(LoggedUser);
  const user = useRecoilState(LoggedUser);
  const [show, setShow] = useState(false);
  const setPermissions = useSetRecoilState(permissions);
  const setSysPermissions = useSetRecoilState(allPermissions);
  const [loading, setLoading] = useState(false);
  const [isOpenEmailModal, setIsOpenEmailModal] = useState(false);
  const image = imagem;

  const handleClick = () => setShow(!show);

  const submitLogin = async (pinCode: string) => {
    try {
      setLoading(true);
      const obj = {
        pwd: values.pwd,
        email: values.email,
        secret: md5(
          `${values.email}-${moment().format("DD/MM/YYYY")}-supervisor`
        ),
      };
      const response = await Login.login(obj, pinCode);

      if (response.statusCode !== 401) {
        setApiResponse(response);
        setCookie("auth", true);
        window.localStorage.setItem("token", response.token);
        setCookie("token", response.token);
        window.localStorage.setItem("refreshToken", response.refreshToken);
        setCookie("refreshToken", response.refreshToken);
        let jwtToken: JWTToken = jwt_decode(response.token || "");
        window.localStorage.setItem("user", JSON.stringify(response.user));
        setCookie("user", response.user);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.token}`;
        setUser({
          email: response.user.email,
          id: response.user.id,
          idEmpresa: response.user.idEmpresa,
          idLoginTipo: response.user.idLoginTipo,
          nome: response.user.nome,
        });
        await getPerms(Number(jwtToken.idCliente));
        setLoading(false);
        goToDashboard(navigate);
      } else {
        setLoading(false);
        toast.error("PIN inválido.");
      }
    } catch (error) {
      setLoading(false);
      toast.error("PIN inválido");
    }
  };

  const submitFirstLogin = async () => {
    try {
      setLoading(true);
      const obj = {
        pwd: values.pwd,
        email: values.email,
        secret: md5(
          `${values.email}-${moment().format("DD/MM/YYYY")}-supervisor`
        ),
      };

      const response: any = await Login.login2(obj);

      if (response.status >= 200 && response.status < 300) {
        setLoading(false);
        setIsOpenEmailModal(true);
      } else {
        setLoading(false);
        toast.error("Erro ao fazer login. Status: " + response.status);
      }
    } catch (error: any) {
      const errLg: any =
        error?.response?.data && typeof error?.response?.data === "string"
          ? error?.response?.data
          : "Email ou senha inválidos, tente novamente.";
      toast.error(errLg);
      setLoading(false);
    }
  };

  async function getPerms(id: number) {
    try {
      const response = await PermissionsAPI.getPermissions(id);
      const res = await PermissionsAPI.getSysPermissions(1, 100);
      setPermissions(response);
      // setSysPermissions(res);
    } catch (error) {
      console.log(error);
    }
  }

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Flex w={"100%"} direction={"column"} px={"4"}>
      <Flex justify={"center"} mt={"-10vh"}>
        <Image src={"./logoBranca.png"} h={"40vh"} />
      </Flex>
      <Flex width={"100%"} direction={"column"} mt={"-12vh"} h={"fit-content"}>
        <Input
          name="email"
          type={"text"}
          required
          bgColor={WHITE}
          borderRadius={"15px"}
          my={2}
          h={"6vh"}
          placeholder="email@dominio.com.br"
          onChange={(e: any) => setValues({ ...values, email: e.target.value })}
        />
        <InputGroup size="md">
          <Input
            name="password"
            type={show ? "text" : "password"}
            required
            bgColor={WHITE}
            borderRadius={"15px"}
            my={2}
            h={"6vh"}
            placeholder="Senha"
            onChange={(e: any) => setValues({ ...values, pwd: e.target.value })}
            onKeyPress={(e: any) => {
              if (e.key === "Enter") {
                submitLogin(e.target.value);
              }
            }}
          />
          <InputRightElement width="4.5rem">
            <IconButton
              mt={"4vh"}
              size="sm"
              onClick={handleClick}
              icon={show ? <ViewOffIcon /> : <ViewIcon />}
              aria-label="Show password"
            />
          </InputRightElement>
        </InputGroup>
        <Button
          color={WHITE}
          type="submit"
          w={"100%"}
          h={"6vh"}
          borderRadius={"15px"}
          onClick={submitFirstLogin}
          bgColor={"#09245B"}
          mt={4}
          _hover={{ backgroundColor: VARIANT }}
          isLoading={loading}
        >
          <Text>Acessar</Text>
        </Button>
        <Flex direction={"row"} py={"2"} justifyContent={"center"}>
          <Text fontSize={"1vw"} mr={"2"} color={WHITE}>
            Esqueceu sua senha?
          </Text>
          <Text
            fontSize={"1vw"}
            fontWeight={"bold"}
            color={WHITE}
            _hover={{ cursor: "pointer" }}
            onClick={() => setIsOpen(true)}
          >
            Clique aqui.
          </Text>
        </Flex>
      </Flex>
      <ModalRequestNewPassword isOpen={isOpen} setIsOpen={setIsOpen} />
      <ModalSelectEmail
        isOpen={isOpenEmailModal}
        setIsOpen={setIsOpenEmailModal}
        email={values.email}
        submitLogin={submitLogin}
      />
    </Flex>
  );
}

export default LoginForm;
